export const Sizes = {
  textfieldWidth: 230
}

export default Sizes


// WEBPACK FOOTER //
// ./src/common/styles/sizes.js